import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, FormBuilder } from '@angular/forms';
import { UsuarioService } from 'src/app/services/';
import { PROJETO } from 'src/app/app.config';
import { TranslateService } from '@ngx-translate/core';
@Component({selector: 'app-recuperar-senha',
  templateUrl: './recuperar-senha.component.html',
  styleUrls: ['./recuperar-senha.component.scss'], standalone: false})
export class RecuperarSenhaComponent implements OnInit {

  @Output()
  recuperou = new EventEmitter<any>();

  email = '';
  senha = '';
  errors: string[];
  success: string;
  form: UntypedFormGroup;
  loadingRecuperarSenha = false;
  projeto = PROJETO;
  constructor(
    private usuarioService: UsuarioService,
    private translate: TranslateService
  ) 
  {
    translate.setDefaultLang('pt');
  }

  ngOnInit() { }

  useLanguage(language: string) {
    this.translate.setDefaultLang(language);
    this.translate.use(language);
  }

  recuperarSenha() {
    delete this.errors;
    delete this.success;
    this.loadingRecuperarSenha = true;
    this.usuarioService.recuperarSenha(this.email).subscribe(
      dados => {
        this.success = this.translate.instant('E-mail com a recuperação da senha enviado!');
        this.loadingRecuperarSenha = false;
      }, erro => {
        console.log('Erro de recuperar');
        console.log(erro.error.mensagem);
        if (erro.status === 400) {
          this.errors = [this.translate.instant(erro.error.mensagem)];
        } else {
          this.errors = [this.translate.instant('Houve algum erro, tente novamente')];
        }
        this.loadingRecuperarSenha = false;
      });
  }
}
